import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const editDetailedSummaryDepreciationModalSchema = yupResolver(
  yup.object({
    observations: yup.string().required('Observações é obrigatória'),
    depreciationValue: yup.string().required('Valor depreciação é obrigatório')
  })
)
